var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 14,
    viewBox: "0 0 3 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.99971C0 2.82679 0.673 3.49985 1.5 3.49985C2.327 3.49985 3 2.82679 3 1.99971C3 1.17263 2.327 0.499573 1.5 0.499573C0.673 0.499573 0 1.17263 0 1.99971Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.99999C0 7.82706 0.673 8.50012 1.5 8.50012C2.327 8.50012 3 7.82706 3 6.99999C3 6.17291 2.327 5.49985 1.5 5.49985C0.673 5.49985 0 6.17291 0 6.99999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.0003C0 12.8273 0.673 13.5004 1.5 13.5004C2.327 13.5004 3 12.8273 3 12.0003C3 11.1732 2.327 10.5001 1.5 10.5001C0.673 10.5001 0 11.1732 0 12.0003Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.43af890f1cde760cf8a86f8470b519f8.svg";
export { ForwardRef as ReactComponent };